import type { ReactNode } from 'react';

export interface StatRowProps {
  label: string;
  value: ReactNode;
}

export const StatRow = ({ label, value }: StatRowProps) => (
  <div className="flex items-center justify-between gap-3">
    <span className="text-subtle">{label}</span>
    <span className="text-foreground">{value}</span>
  </div>
);
